import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 미니게임 리스트
const get_ownereventlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventtoplist: [],
    eventlistcnt: 0,
    eventlist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/event/eventlist",
    headers: { Authorization: "Bearer " + token },
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      type: param.type,
      pageno: param.pageno,
      status_cd: param.status_cd,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        // console.error(response.data.code, response.data.message)
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownereventlist", err);
    result(false, err);
  }
};

// 매장 코스리스트
const get_ownercourselist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventcourselist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/event/eventcourselist",
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_ownercourselist", err);
    result(false, err);
  }
};

// 매장 코스보기
const get_ownercourseview = async (maincourseno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    courseview: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/event/eventcourseview/" + maincourseno,
    headers: { Authorization: "Bearer " + token },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownercourseview", err);
    result(false, err);
  }
};

// 문의글 작성
const set_ownereventwrite = async (form, result) => {
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "POST",
    url: "/event/eventwrite",
    headers: { Authorization: "Bearer " + token },
    data: qs.stringify({
      title: form.title,
      message: form.message,
      point: form.point,
      startdate: form.startdate,
      enddate: form.enddate,
      systemrange: form.systemrange,
      type: form.type,
      distance: form.distance,
      courseno: form.courseno,
      hole: form.hole,
      teebox: form.teebox,
      gender: form.gender,
      status: form.status,
    }),
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_ownereventwrite", err);
    result(false, err);
  }
};

// 매장이벤트정보보기
const get_ownereventview = async (eventno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventinfo: {},
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/event/eventinfo/" + eventno,
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownereventview", err);
    result(false, err);
  }
};

// 문의글 수정
const set_ownereventedit = async (form, eventno, result) => {
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "POST",
    url: "/event/eventwrite/" + eventno,
    headers: { Authorization: "Bearer " + token },
    data: qs.stringify({
      title: form.title,
      message: form.message,
      point: form.point,
      startdate: form.startdate,
      enddate: form.enddate,
      systemrange: form.systemrange,
      type: form.type,
      distance: form.distance,
      courseno: form.courseno,
      hole: form.hole,
      teebox: form.teebox,
      gender: form.gender,
      status: form.status,
    }),
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_ownereventwrite", err);
    result(false, err);
  }
};

// 매장이벤트당첨내역
const get_ownereventwinninglist = async (param, result) => {
  // console.log("param", param);
  let finalData = {
    code: 200,
    message: "Ok",
    eventwvinninglistcnt: 0,
    eventwvinninglist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/event/eventwinninglist/" + param.eventno,
    headers: { Authorization: "Bearer " + token },
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      type: param.type,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownereventwinninglist", err);
    result(false, err);
  }
};

const get_eventwinningranklist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventwinningrankcnt: 0,
    eventwinningranklist: [],
    eventinfo: {},
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url:
      process.env.VUE_APP_API_URL +
      "/event/eventwinningranklist/" +
      param.eventno,
    headers: { Authorization: "Bearer " + token },
    params: {
      gender: param.gender,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_eventwinningranklist", err);
    result(false, err);
  }
};

// 통합관리이벤트정보보기
const get_eventview = async (eventno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    eventinfo: {},
  };

  const options = {
    method: "GET",
    url: "/event/eventview/" + eventno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_eventview", err);
    result(false, err);
  }
};

export default {
  get_ownereventlist,
  get_ownercourselist,
  get_ownercourseview,
  set_ownereventwrite,
  get_ownereventview,
  set_ownereventedit,
  get_ownereventwinninglist,
  get_eventwinningranklist,
  get_eventview,
};
